import { useScreenMessage } from '@gogame/screens';

import { exportEvents } from 'scenes/Events/sources/events';

export const useExportEvents = () => {
  const {
    showErrorMessage,
    showSuccessMessage,
    showMessage,
  } = useScreenMessage();
  return params => {
    showMessage('Download has started');
    return exportEvents(params)
      .catch(e => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      })
      .then(() => {
        showSuccessMessage('Download complete');
      });
  };
};
